import { useCallback } from 'react';
import { useAppStore } from 'store/hooks';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { selectNeedsAnalyticsIntro } from '../selectors';
import { isWeb } from '../../../constants';
const useNavigateToAnalytics = () => {
    const navigation = useMainStackNavigation();
    const store = useAppStore();
    const navigateToAnalytics = useCallback(async () => {
        const state = store.getState();
        const needsAnalyticsIntro = selectNeedsAnalyticsIntro(state);
        if (!needsAnalyticsIntro || isWeb) {
            navigation.navigateDeprecated('Analytics');
        }
        else {
            navigation.navigateDeprecated('AnalyticsIntro');
        }
    }, []);
    return navigateToAnalytics;
};
export default useNavigateToAnalytics;
